export default "__VITE_ASSET__7jmpZSpR__"